import { createSelector } from '@reduxjs/toolkit';

import { InsightsState } from 'app-redux/InsightsState';
import { Geoname } from 'utils/constants';

import { mapDiseaseActivityParamsToMapState, mapDiseaseActivityParamsToPanelState, mapWhatPanelsNeedToReload } from './disacPanelUtils';
import { DiseaseActivityParams, PanelType } from './diseaseActivityPanels.slice';

const getPanelVisibility = (panelType: PanelType) => (state: InsightsState) => state.diseaseActivityPanels.byPanel[panelType];
const disacParams = (state: InsightsState) => state.diseaseActivityPanels.disacParams;
const activePanel = (state: InsightsState) => state.diseaseActivityPanels.activePanel;
const isProximalLayerEnabled = (state: InsightsState) =>
  state.diseaseActivityPanels.isProximalDetailsExpandedDELP || state.diseaseActivityPanels.isProximalDetailsExpandedEDP;
const getPanelState = createSelector(disacParams, p => mapDiseaseActivityParamsToPanelState(p));
const getMapState = createSelector(disacParams, isProximalLayerEnabled, (p, isProx) => mapDiseaseActivityParamsToMapState(p, isProx));
const isHistorySelectedFromActivityList = createSelector(disacParams, p => p.hasActivity && !p.countryId);
const isHistorySelectedFromActivityDetails = createSelector(disacParams, p => p.hasActivity && !!p.countryId);
const getHistoryDeeplinkDate = createSelector(disacParams, p => (p.hasActivity ? p.activityDate : null));
const whatPanelsNeedToReload = (newParams: DiseaseActivityParams) => (state: InsightsState) =>
  mapWhatPanelsNeedToReload(state.diseaseActivityPanels.disacParams, newParams);
const getSelectedLocationId = createSelector(disacParams, p => p.userLocationId);
const isGlobalSelected = createSelector(disacParams, p => p.userLocationId === Geoname.GLOBAL_VIEW);
const isAnyLocationSelected = createSelector(disacParams, p => !!p.userLocationId);
const isLocationSelected = (geonameId: number) => (state: InsightsState) => state.diseaseActivityPanels.disacParams.userLocationId === geonameId;
const isDiseaseSelected = (diseaseId: number) => (state: InsightsState) => state.diseaseActivityPanels.disacParams.diseaseId === diseaseId;
const isHistoryCountrySpecific = createSelector(disacParams, x => !!x?.countryId);
const showProximalHistoryUpdates = createSelector(
  disacParams,
  isHistoryCountrySpecific,
  isGlobalSelected,
  (p, isCountrySpecif, isGlobalSel) => p.hasActivity && !isCountrySpecif && !isGlobalSel
);

// diseaseActivityPanelsSelectors
export default {
  getPanelVisibility,
  disacParams,
  activePanel,
  isProximalLayerEnabled,
  getPanelState,
  getMapState,
  isHistorySelectedFromActivityList,
  isHistorySelectedFromActivityDetails,
  getHistoryDeeplinkDate,
  whatPanelsNeedToReload,
  getSelectedLocationId,
  isGlobalSelected,
  isAnyLocationSelected,
  isLocationSelected,
  isDiseaseSelected,
  isHistoryCountrySpecific,
  showProximalHistoryUpdates,
};
